import React, { useEffect, useState } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ShogGrid from './shop-components/shop-right-sidebar';
// import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const Shop_V1 = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`https://f3mw4bb5.directus.app/items/propiedades`)
      .then(response => response.json())
      .then(result => {
        setData(result.data);
      })
  }, [])
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Propiedades" />
      <ShogGrid properties={data} />
      <Footer />
    </div>
  )
}

export default Shop_V1

